import { Dialog, Button, DialogContent, Typography, AppBar, Toolbar, IconButton } from "@mui/material"
import { Form, useTranslate } from "react-admin"
import { Close } from '@mui/icons-material';
import { SendInvoiceByMailCommand, SendInvoiceReminderByMailCommand, SendReverseInvoiceByMailCommand } from "../../GeneratedClients/FreeBillApi";
import EmailPreview from "./EmailPreview";

interface IProps {
  record: SendInvoiceByMailCommand | SendReverseInvoiceByMailCommand | SendInvoiceReminderByMailCommand
  handleSubmit: (command: SendInvoiceByMailCommand | SendReverseInvoiceByMailCommand | SendInvoiceReminderByMailCommand) => void
  attachments?: {id?: string, attachmentFileName: string, resource: "invoices" | "reverseInvoices" | "invoiceReminders"}[]
  isLoading: boolean
  resource: "invoices" | "reverseInvoices" | "invoiceReminders"
  dialogText?: string
  open: boolean
  handleClose: () => void
}

const SendEmailDialog = ({record, handleSubmit, attachments, isLoading, resource, dialogText, open, handleClose}: IProps) => {
  const translate = useTranslate()


  return (
    <Dialog 
      open={open}
      onClose={handleClose}
      fullScreen
    >
      <Form record={record} onSubmit={handleSubmit}>
        <AppBar sx={{position: 'relative'}}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
            >
              <Close />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} component={'div'} variant="h6" color={"inherit"}>
              {dialogText}
            </Typography>
            <Button variant="contained" color="success" autoFocus type="submit" disabled={isLoading} >{translate('resources.invoices.actions.send')}</Button>
          </Toolbar>
        </AppBar>
        <DialogContent >
          <EmailPreview attachments={attachments} />
        </DialogContent>
      </Form>
    </Dialog>
  )
}

export default SendEmailDialog